var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureTileIcon01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.8,
    fill: "#CCD4FF",
    d: "M32 20h-2v11h-2v2h2v11h2v-4h2v-2h-2V26h2v-2h-2z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#dd1f1f",
    x: 35,
    y: 21,
    width: 8,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#dd1f1f",
    x: 35,
    y: 35,
    width: 8,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#dd1f1f",
    x: 19,
    y: 28,
    width: 8,
    height: 8,
    rx: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon01);
export default __webpack_public_path__ + "static/media/feature-tile-icon-01.7c0fe9bbf167d97295d612c01e68b3ff.svg";
export { ForwardRef as ReactComponent };